import { client } from "../../api/clientAutotask"

export const fetchTicketNoteById = async (id) => {
    var uri = "autotaskapi/ticketnotes/" + id
    var responseAutotask = await client.get(uri)
    return responseAutotask.data
}